import moment from 'moment';

export const TaxNumberParser = () => {
  const extractBirthdayFromTaxNumber = (code, format = 'YYYY-MM-DD') => {
    code = String(code).trim();

    if (!/^\d{10}$/.test(code)) return null;

    const days = parseInt(code.slice(0, 5), 10);
    const birthDate = moment('1899-12-31').add(days, 'days');
    const minDate = moment('1900-01-01');
    const maxDate = moment().add(1, 'day');

    if (birthDate.isAfter(maxDate) || birthDate.isBefore(minDate)) {
      return null;
    }

    return birthDate.format(format);
  };

  return {
    extractBirthdayFromTaxNumber,
  };
};
